import $ from 'jquery';
import Filter from './Filter';

// The search filter
export default class SearchFilter extends Filter {

  constructor($element, options) {
    super($element, options);
    if ($element.length === 0) return false;

    this.filterType = "SearchFilter";
    this.emptyValue = "";

    this.$element.find('input').on('keyup', this.onChange.bind(this));
    this.$element.find('input').on('focus', this.onChange.bind(this));
  }

  onChange(ev) {
    this.setLastUsedInstance();
  }

  getValue() {
    let value = this.getLastUsedInstance().find('input[type=text]').val();

    // Synchronize the other filters
    for(let i = 0; i < window.WJP.query.getFilters(this.getKey()).length ; i++) {
      window.WJP.query.getFilters(this.getKey())[i].setValue(value);
    }
    return value;
  }

  setValue( value ) {
    return this.$element.find('input[type=text]').val(value);
  }

  getKey() {
    return this.getElement().data('key') || this.getElement().data('wjp-filter-key');
  }

  setLastUsedInstance() {
    window.WJP.SearchFilterInstance = this.$element;
  }

  getLastUsedInstance() {
    return window.WJP.SearchFilterInstance || this.$element;
  }
}



/** WEBPACK FOOTER **
 ** ../assets/js/filters/SearchFilter.js
 **/